var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 131,
    viewBox: "0 0 131 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.678 65.0238C116.678 79.1342 110.938 91.9346 101.672 101.2L111.785 111.314C123.642 99.4569 130.991 83.0832 130.991 65.0238C130.991 46.9645 123.642 30.5907 111.785 18.7341L101.672 28.8474C110.938 38.113 116.678 50.9135 116.678 65.0238Z",
    fill: "url(#paint0_radial_361_18846)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.8237 65.0239C94.8237 73.1145 91.5297 80.4441 86.2227 85.7512L93.8413 93.3698C101.104 86.1076 105.602 76.081 105.602 65.0143C105.602 53.9475 101.104 43.921 93.8413 36.6587L86.2227 44.2773C91.5297 49.5844 94.8237 56.9237 94.8237 65.0046V65.0239Z",
    fill: "url(#paint1_radial_361_18846)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3126 65.5543C14.3126 51.444 20.0531 38.6435 29.3187 29.3779L19.2055 19.2646C7.34895 31.1212 0 47.495 0 65.5543C0 83.6137 7.34895 99.9875 19.2055 111.844L29.3187 101.731C20.0531 92.4652 14.3126 79.6647 14.3126 65.5543Z",
    fill: "url(#paint2_radial_361_18846)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1665 65.0239C36.1665 56.9333 39.4605 49.6037 44.7675 44.2966L37.1489 36.678C29.8867 43.9402 25.3887 53.9668 25.3887 65.0335C25.3887 76.1003 29.8867 86.1268 37.1489 93.3891L44.7675 85.7705C39.4605 80.4634 36.1665 73.1241 36.1665 65.0432V65.0239Z",
    fill: "url(#paint3_radial_361_18846)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4952 83.0928C75.4744 83.0928 83.5642 75.003 83.5642 65.0238C83.5642 55.0446 75.4744 46.9548 65.4952 46.9548C55.516 46.9548 47.4263 55.0446 47.4263 65.0238C47.4263 75.003 55.516 83.0928 65.4952 83.0928Z",
    fill: "url(#paint4_linear_361_18846)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_361_18846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.4954 65.0238) scale(65.4952 65.4952)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#BEAEFF",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_361_18846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.4953 65.0239) scale(40.1158 40.1158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BEAEFF",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_361_18846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(67.4265 65.4999) rotate(180) scale(71.2794)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#BEAEFF",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_361_18846",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(65.4948 65.0239) scale(40.1158 40.1158)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#BEAEFF",
    stopOpacity: 0.98
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_361_18846",
    x1: 65.4952,
    y1: 48.3803,
    x2: 65.4952,
    y2: 80.916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEAEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#BEAEFF",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#BEAEFF",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BEAEFF",
    stopOpacity: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLive);
export default __webpack_public_path__ + "static/media/Live.2e7e6b3c6432e53e9c30f7eaa32e4036.svg";
export { ForwardRef as ReactComponent };